import { NodePosition } from './node-position';
import { StepData } from './step-data';

/**
 * Represente une étape de workflow.
 */
export class Step {
    /**
     *
     * @param id : Id de l'étape.
     * @param stepName : Nom de l'étape
     * @param inputs : Liste des socket de type input (correspond à des actions sur l'étape).
     * @param outputs : Liste des socket de type output (correspond à des triggers sur l'étape).
     * @param position : Position du noeud affichant l'étape dans le designer.
     * @param data : Données de l'étape.
     */
    public constructor(
        public id: number,
        public stepName: string,
        public inputs: string[],
        public outputs: string[],
        public position: NodePosition,
        public data: StepData
    ) {}

    /**
     * Retourne une copie d'une instance de Step
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: Step) {
        if (!!other) {
            const instance = new Step(other.id, other.stepName, other.inputs, other.outputs, other.position, other.data);
            instance.id = other.id;
            instance.data.id = instance.id;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de Step
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: Step[]) {
        if (!!others) {
            let steps: Step[] = [];

            others.forEach((x) => {
                const step = Step.clone(x);
                steps.push(step);
            });

            return steps;
        } else {
            return [];
        }
    }
}
